import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Radio, Users, Play } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { api, mediaUrl } from "@/lib/api";
import { Avatar } from "@/components/PostCard";

export default function LivePartiesCard() {
  const navigate = useNavigate();
  const [parties, setParties] = useState([]);

  useEffect(() => {
    const load = () => api.get("/parties").then(({ data }) => setParties(data)).catch(() => {});
    load();
    const i = setInterval(load, 10000);
    return () => clearInterval(i);
  }, []);

  return (
    <AnimatePresence>
      {parties.length > 0 && (
        <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}
          className="nu-card p-5 mb-6" data-testid="live-parties-card">
          <h3 className="flex items-center gap-2 font-bold mb-4">
            <span className="relative flex h-2.5 w-2.5"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" /><span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" /></span>
            Live Listen Parties
          </h3>
          <div className="space-y-3">
            {parties.map((p) => (
              <div key={p.id} className="flex items-center gap-3 p-3 rounded-xl bg-black/40 border border-white/10" data-testid="live-party-item">
                {p.track?.cover_url ? <img src={mediaUrl(p.track.cover_url)} alt="" className="w-12 h-12 rounded-lg object-cover" />
                  : <span className="w-12 h-12 rounded-lg bg-emerald-500/15 flex items-center justify-center"><Radio className="w-5 h-5 text-emerald-400" /></span>}
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-bold truncate">{p.track?.title}</p>
                  <p className="text-xs text-zinc-500 truncate flex items-center gap-1"><Users className="w-3 h-3" /> {p.listeners} · {p.host?.artist_name}</p>
                </div>
                <button onClick={() => navigate(`/party/${p.id}`)} data-testid="join-party-btn"
                  className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-emerald-500 hover:bg-emerald-600 text-black font-bold text-sm transition-colors shrink-0">
                  <Play className="w-4 h-4" /> Join
                </button>
              </div>
            ))}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
